import { ACCENT, MUTED, type IllustrationProps } from './types';

/**
 * IllustrationSealedStock — empty-state art for sealed product inventory.
 *
 * Depicts: a stack of two sealed booster boxes in perspective, the top box
 * highlighted with a barcode strip across its face.
 *
 * Resource: sealed stock. Shell: any.
 */
export function IllustrationSealedStock({ size = 120, className, style }: IllustrationProps) {
  const h = (size * 90) / 120;
  return (
    <svg
      width={size}
      height={h}
      viewBox="0 0 120 90"
      fill="none"
      className={className}
      style={style}
      aria-hidden="true"
    >
      <ellipse cx="60" cy="82" rx="38" ry="3" stroke={MUTED} strokeWidth={1.5} />
      {/* bottom box */}
      <path
        d="M28 56 L28 76 L72 76 L72 56"
        stroke={MUTED}
        strokeWidth={1.5}
        strokeLinejoin="round"
      />
      <path d="M28 56 L50 50 L72 56" stroke={MUTED} strokeWidth={1.5} strokeLinejoin="round" />
      {/* top box (accent) */}
      <path
        d="M40 32 L40 56 L92 56 L92 32 Z"
        stroke={ACCENT}
        strokeWidth={1.5}
        strokeLinejoin="round"
      />
      <path d="M40 32 L66 24 L92 32" stroke={ACCENT} strokeWidth={1.5} strokeLinejoin="round" />
      <path d="M66 24 L66 48" stroke={ACCENT} strokeWidth={1.5} strokeLinejoin="round" />
      <path d="M40 56 L66 48 L92 56" stroke={ACCENT} strokeWidth={1.5} strokeLinejoin="round" />
      {/* barcode strip */}
      <rect x="48" y="40" width="20" height="8" stroke={ACCENT} strokeWidth={1.2} />
      <line x1="51" y1="40" x2="51" y2="48" stroke={ACCENT} strokeWidth={1} />
      <line x1="54" y1="40" x2="54" y2="48" stroke={ACCENT} strokeWidth={1} />
      <line x1="57" y1="40" x2="57" y2="48" stroke={ACCENT} strokeWidth={1} />
      <line x1="61" y1="40" x2="61" y2="48" stroke={ACCENT} strokeWidth={1} />
      <line x1="65" y1="40" x2="65" y2="48" stroke={ACCENT} strokeWidth={1} />
    </svg>
  );
}
